import { createReducer, on } from '@ngrx/store';
import { CountIntegrationByFilterSuccess } from 'src/app/modules/administration/integration-management/actions/integration-management-search.actions';
import {
  GetImportExportLiteralsSuccess,
  LocaleGridSuccess,
  NewLiteralsPagingChanged,
  NewLiteralsPerPageChanged,
} from 'src/app/modules/administration/locale-management/actions/import-export-literals.actions';
import {
  GetSearchLiteralsSuccess,
  LiteralsPagingChanged,
  LiteralsPerPageChanged,
  SearchLiteralsGridSuccess,
} from 'src/app/modules/administration/locale-management/actions/search-literals.actions';
import { GetListsSuccess } from 'src/app/modules/campaign-management/campaigns/actions/lists.actions';
import { CountCheckbooksByFilterSuccess } from 'src/app/modules/campaign-management/checkbooks/actions/search-checkbooks.actions';
import { SearchCountAllCustomersSuccess } from 'src/app/modules/customer-data/customers/actions/all-customers.actions';
import { SearchCountLoyaltyMembersSuccess } from 'src/app/modules/customer-data/customers/actions/members-search.actions';
import { StoreGridSuccess } from 'src/app/modules/data-customization/store-management/actions/search.actions';
import { ClearGrid, GridFailed, GridSuccess } from '../actions/grid.actions';
import {
  CountChanged,
  ItemsPerPageChanged,
  OrderingChanged,
  OrderingInit,
  PagingChanged,
  ResetPaging,
  SortingChanged,
  SortingInit,
} from '../actions/paginator.actions';
import { Paginator } from '../models/grid.model';

export interface PaginatorState {
  itemsPerPage: number[];
  itemsNumber: number;
  selectedSortField: string;
  selectedOrder: string;
  paginator: Paginator;
  totalPages: number;
  sortFieldOptions: string[];
  orderFieldOptions: string[];
}

const initialState: PaginatorState = {
  itemsPerPage: [5, 10, 20, 50],
  itemsNumber: 10,
  selectedSortField: '',
  selectedOrder: '',
  paginator: {
    previousPageIndex: 0,
    pageIndex: 0,
    pageSize: 0,
    length: 0,
  },
  totalPages: 0,
  sortFieldOptions: [],
  orderFieldOptions: [],
};

export const PaginatorReducer = createReducer(
  initialState,
  on(GridSuccess, StoreGridSuccess, (state, { res }) => {
    if ('payload' in res) {
      return {
        ...state,
        totalPages: res.payload.filterResults?.totalResults,
      };
    }
    return {
      ...state,
    };
  }),
  on(CountChanged, (state, { totalPages }) => ({
    ...state,
    totalPages,
  })),
  on(GridFailed, () => initialState),
  on(ClearGrid, () => initialState),
  on(SortingInit, (state, { sortFieldOptions, selectedSortField }) => ({
    ...state,
    sortFieldOptions,
    selectedSortField,
  })),
  on(OrderingInit, (state, { orderFieldOptions, selectedOrder }) => ({
    ...state,
    orderFieldOptions,
    selectedOrder,
  })),
  on(ItemsPerPageChanged, (state, { itemsNumber }) => ({
    ...state,
    itemsNumber,
    paginator: {
      ...state.paginator,
      pageIndex: 0,
    },
  })),
  on(SortingChanged, (state, { selectedSortField }) => ({
    ...state,
    selectedSortField,
    paginator: {
      ...state.paginator,
      pageIndex: 0,
    },
  })),
  on(OrderingChanged, (state, { selectedOrder }) => ({
    ...state,
    selectedOrder,
    paginator: {
      ...state.paginator,
      pageIndex: 0,
    },
  })),
  on(PagingChanged, (state, { paginator }) => ({
    ...state,
    paginator,
  })),
  on(ResetPaging, (state) => ({
    ...state,
    paginator: {
      previousPageIndex: 0,
      pageIndex: 0,
      pageSize: 0,
      length: 0,
    },
  })),
  on(CountIntegrationByFilterSuccess, (state, { response }) => ({
    ...state,
    totalPages: +response.payload.data,
  })),
  on(CountCheckbooksByFilterSuccess, (state, { response }) => ({
    ...state,
    totalPages: +response,
  })),
  on(GetListsSuccess, (state, { res }) => ({
    ...state,
    totalPages: res.length,
    itemsNumber: res.length,
  })),
  on(GetSearchLiteralsSuccess, (state, { res }) => ({
    ...state,
    totalPages: res.length,
  })),
  on(GetImportExportLiteralsSuccess, (state, { res }) => ({
    ...state,
    totalPages: res.length,
  })),
  on(SearchCountLoyaltyMembersSuccess, (state, { res }) => ({
    ...state,
    totalPages: res,
  })),
  on(SearchCountAllCustomersSuccess, (state, { res }) => ({
    ...state,
    totalPages: res,
  })),
  on(LocaleGridSuccess, (state, { res }) => {
    const itemsPerPage = state.itemsNumber;
    const totalItems = state.totalPages;
    const totalPages = totalItems;

    return {
      ...state,
      totalPages,
      paginator: {
        ...state.paginator,
        pageIndex: state.paginator.pageIndex,
        pageSize: itemsPerPage,
        length: totalItems,
      },
      data: res.map((item: any) => ({ ...item, isSelectedLiteral: true })),
    };
  }),
  on(SearchLiteralsGridSuccess, (state, { res }) => {
    const itemsPerPage = state.itemsNumber;
    const totalItems = state.totalPages;
    const totalPages = totalItems;

    return {
      ...state,
      totalPages,
      paginator: {
        ...state.paginator,
        pageIndex: state.paginator.pageIndex,
        pageSize: itemsPerPage,
        length: totalItems,
      },
      data: res.map((item: any) => ({ ...item })),
    };
  }),
  on(NewLiteralsPerPageChanged, (state, { itemsNumber }) => ({
    ...state,
    itemsNumber,
    paginator: {
      ...state.paginator,
      pageIndex: 0,
    },
  })),
  on(NewLiteralsPagingChanged, (state, { paginator }) => ({
    ...state,
    paginator,
  })),
  on(LiteralsPerPageChanged, (state, { itemsNumber }) => ({
    ...state,
    itemsNumber,
    paginator: {
      ...state.paginator,
      pageIndex: 0,
    },
  })),
  on(LiteralsPagingChanged, (state, { paginator }) => ({
    ...state,
    paginator,
  })),
);
